
























import { Component, Vue } from 'vue-property-decorator';
import jwtDecode from 'jwt-decode';

import flagKeys from '@/constants/flagKeys';

import segmentIo from '@/utils/segment.io';

import CheckIcon from '@/components/icons/CheckBig.vue';
import ClockSolidIcon from '@/components/icons/ClockSolid.vue';
import TwismLogoIcon from '@/components/icons/TwismLogo.vue';

import SignUpService from '@/api/SingupService';
import { isExternalOauthSessionOnline } from '@/router/router-utils';

@Component({
  components: {
    CheckIcon,
    ClockSolidIcon,
    TwismLogoIcon
  }
})
export default class WaitingForApproval extends Vue {
  service = new SignUpService();

  get tPrefix() {
    return 'businessSignup.success';
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get email() {
    const managerCredentials = this.service.getCredentials();

    return jwtDecode(managerCredentials).extraInfo.mail;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  created() {
    segmentIo.page('NPO Sign Up/Existing Address Wait for CX', {
      'Signup Online': !!isExternalOauthSessionOnline()
    });
  }
}
